<template>
  <div v-loading="loading" style="height:650px; overflow: auto;">
    <div ref="tablePrint" class="print">
      <div style="margin-top: 10px; height: 650px; overflow: auto">
        <div id="tablePrint">
          <shiftBusinessTable :collectionTabelTitel="collectionTabelTitel" :unCollectionAndHouse="unCollectionAndHouse"
            :handoverSalesTotal="handoverSalesTotal" :salesTabelTitel="salesTabelTitel" :statisticsData="statisticsData"
            :statisticsSum="statisticsSum" :sumsCollection="sumsCollection" :sumsSalesTotal="sumsSalesTotal"
            :listQuery="listQuery" :options='options' :outletsListArr="outletsListArr"></shiftBusinessTable>
        </div>
      </div>
    </div>

    <div ref="tablePrintExport" class="Export_table" v-show="false"   >
      <div style="margin-top: 10px; height: 650px; overflow: auto">
        <div id="tablePrintExport">
          <shiftBusinessTable :collectionTabelTitel="collectionTabelTitel" :unCollectionAndHouse="unCollectionAndHouse"
            :handoverSalesTotal="handoverSalesTotal" :salesTabelTitel="salesTabelTitel" :statisticsData="statisticsData"
            :statisticsSum="statisticsSum" :sumsCollection="sumsCollection" :sumsSalesTotal="sumsSalesTotal"
            :listQuery="listQuery" :exportShow="true" :outletsListArr="outletsListArr" :options='options'>
          </shiftBusinessTable>
        </div>
      </div>
    </div>
    <div id="copy_div" v-show="false" style="'width:100%'" class="flex-seting"></div>
  </div>
</template>
<script>
  import DateUtils from "@/utils/DateUtils";
  import shiftBusinessTable from "./shiftBusinessTable";
  import getLodop from '../../utils/Lodopfuncs'

  export default {
    components: {
      shiftBusinessTable
    },
    data() {
      return {
        listQuery: {
          shiftCode: "",
          userId: "",
          outletId: "",
          startTime: DateUtils.formatDate(new Date(), "yyyy-MM-dd "),
          endTime: DateUtils.formatDate(new Date(), "yyyy-MM-dd "),
        },
        employee: JSON.parse(localStorage.getItem('user')),
        currentTime: DateUtils.formatDate(new Date(), "yyyy-MM-dd hh:mm"), //当前的时间
        hotelInfo: JSON.parse(localStorage.getItem('hotel')),
        loading: false,
        collectionTabelTitel: [],
        unCollectionAndHouse: [],
        handoverSalesTotal: [],
        salesTabelTitel: [],
        statisticsData: [],
        statisticsSum: {
          people_count: 0,
          avgPeoplePrice: 0,
          orderCount: 0,
          avgOrderPrice: 0,
          billCount: 0,
        },
        outletsListArr: [],
        options: []


      };
    },
    created() {
      this.getInit();
      this.$bus.$on("todoQuery", this.getData);
      this.$bus.$on("todoPrintCatering", this.todoPrint);
      this.$bus.$on("todoExportCatering", this.todoExport);
    },
    beforeDestroy() {
      this.$bus.$off("todoQuery", this.getData);
      this.$bus.$off("todoPrintCatering", this.todoPrint);
      this.$bus.$off("todoExportCatering", this.todoExport);
    },
    computed: {
      sumsCollection: function () {
        let sums = [];
        sums[this.collectionTabelTitel.length - 1] = undefined;
        this.collectionTabelTitel.map((item, index) => {
          this.unCollectionAndHouse.map((sItem) => {
            sItem[item.productCode] = sItem[item.productCode] ?
              sItem[item.productCode] :
              0;
            if (typeof sItem[item.productCode] == "number") {
              if (!sums[index]) {
                sums[index] = 0;
              }
              sums[index] += sItem[item.productCode] ?
                sItem[item.productCode] :
                0;
            }
          });
        });

        if (this.collectionTabelTitel.length) {
          sums[0] = "合计";
        }
        return sums;
      },
      sumsSalesTotal: function () {
        let sums = [];
        sums[this.salesTabelTitel.length - 1] = undefined;
        this.salesTabelTitel.map((item, index) => {
          this.handoverSalesTotal.map((sItem) => {
            sItem[item.code] = sItem[item.code] ? sItem[item.code] : 0;
            if (typeof sItem[item.code] == "number") {
              if (!sums[index]) {
                sums[index] = 0;
              }
              sums[index] += sItem[item.code] ? sItem[item.code] : 0;
            }
          });
        });
        if (this.salesTabelTitel.length) {
          sums[0] = "合计";
        }
        return sums;
      },
    },
    methods: {
      getData(val) {
        console.log("getData", val);
        this.listQuery = Object.assign({}, val);
        this.getInit();
      },
      getInit() {
        // 销售数据拼接
        var methods = "get"
        let url = this.api.statisticsReport2
        let data = this.listQuery
        this.$axios({
          url,
          methods,
          data
        }).then((res) => {
          if (res.data.status == 0) {
            this.statisticsData = res.data.data;

            this.statisticsSum = {
              people_count: 0,
              avgPeoplePrice: 0,
              orderCount: 0,
              avgOrderPrice: 0,
              billCount: 0,
            };
            // 统计合计
            this.statisticsData.map((v) => {
              this.statisticsSum.people_count += v.people_count ?
                v.people_count :
                0;
              this.statisticsSum.avgPeoplePrice +=
                (v.avgPeoplePrice ? v.avgPeoplePrice : 0) * v.people_count;
              this.statisticsSum.orderCount += v.orderCount ? v.orderCount : 0;
              this.statisticsSum.avgOrderPrice +=
                (v.avgOrderPrice ? v.avgOrderPrice : 0) * v.orderCount;
              this.statisticsSum.billCount += v.billCount ? v.billCount : 0;
            });
          }
        });
         url = this.api.collectionReport

        this.$axios({
          url,
          methods,
          data
        }).then((res) => {
          if (res.data.status == 0) {
            this.collectionTabelTitel =
              res.data.data && res.data.data.tabelTitel.length > 0 ?
              res.data.data.tabelTitel : [];
            // 添加转房账和未接/挂账
            this.collectionTabelTitel.push({
              productCode: "housePrice",
              productName: "转房账",
            });
            this.collectionTabelTitel.push({
              productCode: "unsettled",
              productName: "未结/挂账",
            });
            this.collectionTabelTitel.push({
              productCode: "all_price",
              productName: "合计",
            });
            // 在第一条插入营业点
            this.collectionTabelTitel.unshift({
              productCode: "outletsName",
              productName: "营业点",
            });
            let map = new Map();
            this.unCollectionAndHouse =
              res.data.data && res.data.data.unCollectionAndHouse.length > 0 ?
              res.data.data.unCollectionAndHouse : [];
            console.log(2315435, this.unCollectionAndHouse);
            let collectionData =
              res.data.data && res.data.data.collection.length > 0 ?
              res.data.data.collection : [];
            collectionData.forEach((item) => {
              if (map.has(item.outletCode)) {
                map.get(item.outletCode).push(item);
              } else {
                map.set(item.outletCode, [item]);
              }
            });
            map.forEach((item) => {
              let find = this.unCollectionAndHouse.find(
                (v) => v.outletsCode == item[0].outletCode
              );
              find.all_price = 0;
              //不计算未结/挂账
              find.all_price += find.housePrice ? find.housePrice : 0;
              //计算未结/挂账
              item.forEach((sub) => {
                if (find) {
                  find[sub.productCode] = sub.total_price;
                  find.all_price += sub.total_price;
                }
              });
            });

          }
        });
   url = this.api.handoverSalesReport

        this.$axios({
          url,
          methods,
          data
        }).then((res) => {
          if (res.data.status == 0) {
            this.salesTabelTitel =
              res.data.data && res.data.data.tabelTitel.length > 0 ?
              res.data.data.tabelTitel : [];
            // 添加转房账和未接/挂账
            this.salesTabelTitel.push({
              code: "server_price",
              chinese_desc: "服务费",
            });
            this.salesTabelTitel.push({
              code: "tax",
              chinese_desc: "税率"
            });
            this.salesTabelTitel.push({
              code: "discount",
              chinese_desc: "折扣"
            });
            this.salesTabelTitel.push({
              code: "all_price",
              chinese_desc: "合计",
            });
            // 在第一条插入营业点
            this.salesTabelTitel.unshift({
              code: "outletName",
              chinese_desc: "营业点",
            });
            let mapStatistics = new Map();
            this.handoverSalesTotal =
              res.data.data && res.data.data.handoverSalesTotal.length > 0 ?
              res.data.data.handoverSalesTotal : [];
            let handoverSales =
              res.data.data && res.data.data.handoverSales.length > 0 ?
              res.data.data.handoverSales : [];
            handoverSales.forEach((item) => {
              if (mapStatistics.has(item.outletCode)) {
                mapStatistics.get(item.outletCode).push(item);
              } else {
                mapStatistics.set(item.outletCode, [item]);
              }
            });
            mapStatistics.forEach((item) => {
              let findHand = this.handoverSalesTotal.find(
                (v) => v.outletCode == item[0].outletCode
              );
              item.forEach((sub) => {
                if (findHand) {
                  findHand[sub.code] = sub.total_price;
                }
              });
            });
          }
        });
        if (this.listQuery.outletId.length) {
          this.outletsListArr = []
          url = this.api.bookByOutlets,
          methods = "get",
          data = {
            posCode: localStorage.getItem('posCode')
          }
        this.$axios({
          url,
          methods,
          data
        }).then(res => {
            if (res.data.status === 0) {

              res.data.data.forEach(e => {
                this.listQuery.outletId.forEach(item => {
                  if (item == e.id) {
                    this.outletsListArr.push(e.description)
                  }
                })


              })
            }
          })
        }
        if (this.listQuery.userId.length) {
          this.options = []
          fetchRegisterEmployee().then(res => {
            if (res.data.status === 0) {
              res.data.data.forEach(e => {
                this.listQuery.userId.forEach(item => {

                  if (item == e.user_id) {
                    this.options.push(e.name)
                  }
                })
              })
              console.log(this.options, res.data.data);

            }
          })
        }

      },
      todoPrint(type) {
        const LODOP = getLodop();
        // 获取大小和宽度
        let printSize = 12;
        let width = 2;
        if (LODOP) {
          // 判断是否是数字
          let falg = false;
          if (document.getElementById("tablePrint")) {

            document.getElementById("copy_div").innerHTML = "";
            let innerHTML = document.getElementById("tablePrint").cloneNode(true);
            innerHTML.style.border = "none";
            innerHTML.style.borderCollapse = "collapse";
            innerHTML.style.fontSize = printSize + "px";
            document.getElementById("copy_div").appendChild(innerHTML);
            falg = true;
          }
          this.$nextTick(() => {
            var strFormHtml =
              `
                <body >` +
              document.getElementById(falg ? "copy_div" : "tablePrint")
              .innerHTML +
              "</body>"; //获取打印内容
            LODOP.PRINT_INIT(""); //初始化
            LODOP.SET_PRINT_PAGESIZE(1, 0, 0, "A4"); //设置纵向
            LODOP.ADD_PRINT_HTM(
              "2%",
              width + "%",
              100 - width * 2 + "%",
              "88%",
              strFormHtml
            );
            LODOP.SET_PRINT_STYLEA(0, "Offset2Top", -100);
            LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", 0);
            LODOP.SET_PREVIEW_WINDOW(2, 0, 0, 800, 600, ""); //设置预览窗口模式和大小
            if (type === "preview") {
              LODOP.PREVIEW();
            } else {
              LODOP.PRINT();
            }
          });
        }
      },
      todoExport() {
        const LODOP = getLodop();
        if (LODOP) {
          // 获取大小和宽度
          let width = 2;
          var strFormHtml =
            "<body>" +
            document.getElementById("tablePrintExport").innerHTML +
            "</body>"; //获取打印内容
          LODOP.PRINT_INIT(""); //初始化
          LODOP.SET_PRINT_PAGESIZE(1, 0, 0, "A4"); //设置纵向
          LODOP.ADD_PRINT_TABLE(
            "2%",
            width + "%",
            100 - width * 2 + "%",
            "88%",
            strFormHtml
          );
          LODOP.SET_PRINT_STYLEA(0, "Offset2Top", -100);
          LODOP.SAVE_TO_FILE("营业点交班表.xlsx");
        }
      },
    },
  };
</script>